
function handleImage(image) {

  if (image === 'google') {
    return require('@assets/images/logos/google.png')
  }
  else if (image === 'google-drive') {
    return require('@assets/images/logos/google-drive.png')
  }
  else if (image === 'xero') {
    return require('@assets/images/logos/xero.png')
  }
  else if (image === 'sumup') {
    return require('@assets/images/logos/sumup.png')
  }
  else if (image === 'square') {
    return require('@assets/images/logos/square.png')
  }
  else if (image === 'hubspot') {
    return require('@assets/images/logos/hubspot.png')
  }
  else if (image === 'salesforce') {
    return require('@assets/images/logos/salesforce.png')
  }
  else if (image === 'zapier') {
    return require('@assets/images/logos/zapier.png')
  }
  else if (image === 'canva') {
    return require('@assets/images/logos/canva.png')
  }
  else if (image ==='stripe'){
    return require('@assets/images/logos/stripe.png')
  }
}
export default handleImage;